import {throttle} from 'lodash'

const BCInfiniteScroll = (el, {value, modifiers}) => {
  // scroll target (the element with the scroll bar)
  let target = el
  // threshold to trigger the scrollEnd event ranges from 0 - 100
  let threshold = value.threshold || 80
  // the visible scroll height
  let clientHeight
  // the full scroll height
  let scrollHeight
  // distance from the top to the scroll
  let scrollTop = 0
  // keep track of the previous value to check the direction
  let lastScrollTop = 0
  // throttle configuration, use directive modifier to override
  let leading = modifiers.leading === undefined ? false : modifiers.leading
  let trailing = modifiers.trailing === undefined ? true : modifiers.trailing
  // throttle wait, use directive value to override
  let wait = value.wait || 500

  const getScrollParent = (node) => {
    const regex = /(auto|scroll)/
    const getNodeParents = (_node, parents) => {
      if (_node.parentNode === null) return parents
      return getNodeParents(_node.parentNode, parents.concat([_node]))
    }
    const getStyleValueByProp = _node => prop => getComputedStyle(_node, null).getPropertyValue(prop)
    const getOverflowValues = _node => ['overflow', 'overflow-y', 'overflow-x'].map(getStyleValueByProp(_node))
    const isScrollable = _node => getOverflowValues(_node).some(value => regex.test(value))

    if (!(node instanceof HTMLElement || node instanceof SVGElement)) {
      return
    }

    const parents = getNodeParents(node, [])

    for (let i = 0; i < parents.length; i++) {
      if (isScrollable(parents[i])) {
        return parents[i]
      }
    }

    return document.scrollingElement || document.documentElement
  }

  const updateValues = () => {
    clientHeight = target.clientHeight
    scrollHeight = target.scrollHeight
    lastScrollTop = scrollTop
    scrollTop = target.scrollTop
  }

  const getScrollPercentage = () => {
    return Math.round((clientHeight + scrollTop) * 100 / scrollHeight)
  }

  const isScrollingUp = () => {
    return lastScrollTop > scrollTop
  }

  const isThresholdCrossed = () => {
    return getScrollPercentage() >= threshold
  }

  const onScroll = () => {
    updateValues()

    if (isThresholdCrossed() && !isScrollingUp()) {
      const event = new CustomEvent('scrollEnd')
      el.dispatchEvent(event)
    }
  }

  const init = () => {
    if (value.target) {
      target = document.querySelector(value.target)
      if (!target) return
    } else {
      target = getScrollParent(el)
    }
    if (target) {
      target.onscroll = throttle(onScroll, wait, { leading, trailing })
    }
  }

  init()
}

export default BCInfiniteScroll
